var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeofence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 5.5,
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 18.2229C17.2279 18.2229 18.2229 17.2279 18.2229 16.0006C18.2229 14.7733 17.2279 13.7784 16.0006 13.7784C14.7734 13.7784 13.7784 14.7733 13.7784 16.0006C13.7784 17.2279 14.7734 18.2229 16.0006 18.2229Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3895 15.4451H20.9679C20.7107 13.1316 18.8699 11.2906 16.5562 11.0334V9.61177C16.5562 9.45823 16.432 9.33398 16.2784 9.33398H15.7229C15.5693 9.33398 15.4451 9.45823 15.4451 9.61177V11.0334C13.1314 11.2906 11.2906 13.1316 11.0334 15.4451H9.61177C9.45823 15.4451 9.33398 15.5693 9.33398 15.7229V16.2784C9.33398 16.432 9.45823 16.5562 9.61177 16.5562H11.0334C11.2906 18.8697 13.1314 20.7107 15.4451 20.9679V22.3895C15.4451 22.5431 15.5693 22.6673 15.7229 22.6673H16.2784C16.432 22.6673 16.5562 22.5431 16.5562 22.3895V20.9679C18.8699 20.7107 20.7107 18.8697 20.9679 16.5562H22.3896C22.5431 16.5562 22.6673 16.432 22.6673 16.2784V15.7229C22.6673 15.5693 22.5431 15.4451 22.3895 15.4451ZM16.0007 19.8895C13.8566 19.8895 12.1118 18.145 12.1118 16.0007C12.1118 13.8563 13.8566 12.1118 16.0007 12.1118C18.1447 12.1118 19.8895 13.8563 19.8895 16.0007C19.8895 18.145 18.1447 19.8895 16.0007 19.8895Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeofence);
export default __webpack_public_path__ + "static/media/geofence.35d270f92359c37084f7c0838a309178.svg";
export { ForwardRef as ReactComponent };